import { render, staticRenderFns } from "./BcbCampaignCreate.vue?vue&type=template&id=4e396f39&scoped=true"
import script from "./BcbCampaignCreate.vue?vue&type=script&lang=js"
export * from "./BcbCampaignCreate.vue?vue&type=script&lang=js"
import style0 from "./BcbCampaignCreate.vue?vue&type=style&index=0&id=4e396f39&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e396f39",
  null
  
)

export default component.exports